<template>
  <div class="app">
    <!-- Navigation -->
    <nav class="navbar">
      <div class="nav-container">
        <div class="nav-logo">
          <img class="logo-icon" src="./assets/icon-1024.png" alt="放心聊" />
          <span class="logo-text">放心聊</span>
        </div>
        <div class="nav-links" :class="{ active: mobileMenuOpen }">
          <a href="#features" @click="mobileMenuOpen = false">功能特性</a>
          <a href="#download" @click="mobileMenuOpen = false">下载</a>
          <a href="#security" @click="mobileMenuOpen = false">安全</a>
        </div>
        <button class="mobile-menu-btn" @click="mobileMenuOpen = !mobileMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-bg-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
      <div class="hero-container">
        <div class="hero-content">
          <h1>
            <span class="hero-brand">放心聊</span>
            
          </h1>
          <p class="hero-desc">
            极致安全的私密聊天软件。端到端加密保护每一条消息，阅后即焚让对话不留痕迹。在这里，你的隐私真正属于你。
          </p>
          <div class="hero-actions">
            <a href="#download" class="btn btn-primary">立即下载</a>
            <a href="#features" class="btn btn-secondary">了解更多</a>
          </div>
          <div class="hero-badges">
            <span class="badge">无广告</span>
            <span class="badge">免费使用</span>
            <span class="badge">开源审计</span>
          </div>
        </div>
        <div class="hero-phone">
          <div class="phone-frame">
            <div class="phone-screen">
              <div class="phone-header">
                <span class="phone-title">放心聊</span>
                <div class="phone-search">搜索用户昵称</div>
              </div>
              <div class="chat-list">
                <div class="chat-item">
                  <div class="chat-avatar system">系</div>
                  <div class="chat-info">
                    <div class="chat-name">系统消息</div>
                    <div class="chat-msg">系统消息 - 快去看看吧</div>
                  </div>
                  <div class="chat-time">16:41</div>
                </div>
                <div class="chat-item">
                  <div class="chat-avatar group">群</div>
                  <div class="chat-info">
                    <div class="chat-name">群聊名称(200)</div>
                    <div class="chat-msg">小李加入了群聊</div>
                  </div>
                  <div class="chat-time">2025/05/29</div>
                </div>
                <div class="chat-item">
                  <div class="chat-avatar user1">山</div>
                  <div class="chat-info">
                    <div class="chat-name">小山胖</div>
                    <div class="chat-msg">我是你的新好友，快来和我互动吧~</div>
                  </div>
                  <div class="chat-time">前天</div>
                </div>
                <div class="chat-item">
                  <div class="chat-avatar user2">拂</div>
                  <div class="chat-info">
                    <div class="chat-name">拂雪听松</div>
                    <div class="chat-msg">我是你的新好友，快来和我互动吧~</div>
                  </div>
                  <div class="chat-time">15:36</div>
                </div>
                <div class="chat-item">
                  <div class="chat-avatar user3">桃</div>
                  <div class="chat-info">
                    <div class="chat-name">桃桃乌龙茶</div>
                    <div class="chat-msg">你好呀~</div>
                  </div>
                  <div class="chat-time">昨天</div>
                </div>
              </div>
              <div class="phone-tab-bar">
                <div class="tab active">消息</div>
                <div class="tab">通话</div>
                <div class="tab">好友</div>
                <div class="tab">我的</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section id="features" class="features">
      <div class="section-container">
        <h2 class="section-title">为什么选择放心聊？</h2>
        <p class="section-subtitle">我们专注于隐私保护，让每一次对话都安全无忧</p>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="22" stroke="url(#g1)" stroke-width="2" />
                <path d="M24 12l-10 6v8c0 7 4.5 11.5 10 13 5.5-1.5 10-6 10-13v-8l-10-6z" fill="url(#g1)" opacity="0.15" />
                <path d="M24 12l-10 6v8c0 7 4.5 11.5 10 13 5.5-1.5 10-6 10-13v-8l-10-6z" stroke="url(#g1)" stroke-width="2" fill="none" />
                <path d="M18 24l4 4 8-8" stroke="url(#g1)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <defs><linearGradient id="g1" x1="0" y1="0" x2="48" y2="48"><stop stop-color="#07C9B5"/><stop offset="1" stop-color="#0ae8d1"/></linearGradient></defs>
              </svg>
            </div>
            <h3>端到端加密</h3>
            <p>采用军用级加密算法，只有你和对方能读取消息内容</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="22" stroke="url(#g2)" stroke-width="2" />
                <path d="M16 24a8 8 0 1116 0" stroke="url(#g2)" stroke-width="2" fill="none" />
                <circle cx="24" cy="32" r="3" fill="url(#g2)" />
                <path d="M24 14v4" stroke="url(#g2)" stroke-width="2" stroke-linecap="round" />
                <path d="M30 16l-2 3" stroke="url(#g2)" stroke-width="2" stroke-linecap="round" />
                <path d="M18 16l2 3" stroke="url(#g2)" stroke-width="2" stroke-linecap="round" />
                <defs><linearGradient id="g2" x1="0" y1="0" x2="48" y2="48"><stop stop-color="#f59e0b"/><stop offset="1" stop-color="#ef4444"/></linearGradient></defs>
              </svg>
            </div>
            <h3>阅后即焚</h3>
            <p>消息阅读后自动销毁，不留任何痕迹，保护你的隐私</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="22" stroke="url(#g3)" stroke-width="2" />
                <rect x="14" y="18" width="8" height="14" rx="2" stroke="url(#g3)" stroke-width="2" fill="none" />
                <rect x="26" y="14" width="10" height="18" rx="2" stroke="url(#g3)" stroke-width="2" fill="none" />
                <path d="M22 22h4" stroke="url(#g3)" stroke-width="2" stroke-linecap="round" />
                <defs><linearGradient id="g3" x1="0" y1="0" x2="48" y2="48"><stop stop-color="#06b6d4"/><stop offset="1" stop-color="#3b82f6"/></linearGradient></defs>
              </svg>
            </div>
            <h3>多端同步</h3>
            <p>手机、平板、电脑无缝切换，消息实时同步</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="22" stroke="url(#g4)" stroke-width="2" />
                <path d="M14 30l6-8 4 4 6-8 6 6" stroke="url(#g4)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
                <circle cx="36" cy="18" r="3" fill="url(#g4)" opacity="0.3" />
                <path d="M33 18h3v3" stroke="url(#g4)" stroke-width="1.5" stroke-linecap="round" />
                <defs><linearGradient id="g4" x1="0" y1="0" x2="48" y2="48"><stop stop-color="#10b981"/><stop offset="1" stop-color="#059669"/></linearGradient></defs>
              </svg>
            </div>
            <h3>极速体验</h3>
            <p>轻量级设计，秒级启动，流畅不卡顿</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Security Section -->
    <section id="security" class="security">
      <div class="section-container">
        <div class="security-content">
          <div class="security-text">
            <h2>你的隐私<br />由你掌控</h2>
            <p>
              在放心聊，我们相信隐私是每个人的基本权利。我们采用最先进的加密技术，确保你的每一条消息都安全无忧。
            </p>
            <div class="security-tags">
              <span class="sec-tag">AES-256加密</span>
              <span class="sec-tag">Signal协议</span>
              <span class="sec-tag">双重认证</span>
            </div>
          </div>
          <div class="security-cards">
            <div class="sec-card">
              <div class="sec-card-icon">🔐</div>
              <h4>零知识架构</h4>
              <p>服务器无法读取你的任何消息内容</p>
            </div>
            <div class="sec-card">
              <div class="sec-card-icon">📖</div>
              <h4>开源审计</h4>
              <p>代码完全开源，接受全球安全专家审计</p>
            </div>
            <div class="sec-card">
              <div class="sec-card-icon">🚫</div>
              <h4>无广告无追踪</h4>
              <p>不收集用户数据，不投放任何广告</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Download Section -->
    <section id="download" class="download">
      <div class="section-container">
        <h2 class="section-title">立即下载</h2>
        <p class="section-subtitle">选择你的平台，开始安全的聊天体验</p>
        <div class="download-grid">
          <div class="download-card">
            <div class="download-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <path d="M34.6 38.4c-1.4 1.6-2.9 1.3-4.4.6-1.6-.7-3-.8-4.7 0-2.1 1-3.2.7-4.5-.6C13.5 30.5 14.4 19.3 22.5 18.9c1.9.1 3.2 1 4.3 1.1 1.6-.3 3.2-1.2 4.9-1.1 2.1.2 3.6 1 4.7 2.5-4.3 2.6-3.3 8.3 1.3 9.9-.8 2.1-1.8 4.1-3.1 5.1zM29.5 12c-3.8.3-6.9 4-6.5 7.2 3.5.3 6.9-3.5 6.5-7.2z" fill="#333"/>
              </svg>
            </div>
            <h3>iOS</h3>
            <p class="download-req">支持 iOS 14.0 及以上</p>
            <a :href="iosDownloadUrl" class="btn btn-download">{{ iosButtonText }}</a>
          </div>
          <div class="download-card">
            <div class="download-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <path d="M7.2 36.8L23.5 3.5c.2-.4.8-.4 1 0l16.3 33.3H7.2z" fill="none" stroke="#3DDC84" stroke-width="2"/>
                <circle cx="18" cy="26" r="2" fill="#3DDC84"/>
                <circle cx="30" cy="26" r="2" fill="#3DDC84"/>
                <path d="M16 14l-3-5M32 14l3-5" stroke="#3DDC84" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <h3>Android</h3>
            <p class="download-req">支持 Android 8.0 及以上</p>
            <a :href="androidDownloadUrl" class="btn btn-download">下载 APK</a>
          </div>
          <div class="download-card">
            <div class="download-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <rect x="8" y="8" width="32" height="32" rx="2" fill="none" stroke="#0078D4" stroke-width="2"/>
                <path d="M8 8h15v15H8zM25 8h15v15H25zM8 25h15v15H8zM25 25h15v15H25z" fill="#0078D4" opacity="0.15" stroke="#0078D4" stroke-width="1"/>
              </svg>
            </div>
            <h3>Windows</h3>
            <p class="download-req">支持 Windows 10/11</p>
            <a :href="pcDownloadUrl" class="btn btn-download">下载 PC 版</a>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-brand">
          <div class="footer-logo">
            <img class="logo-icon small" src="./assets/icon-1024.png" alt="放心聊" />
            <span>放心聊</span>
          </div>
          <p class="footer-tagline">© 2026 放心聊 · 你的隐私，由你掌控</p>
        </div>
        <div class="footer-links">
          <a href="#">隐私政策</a>
          <a href="#">用户协议</a>
          <a href="#">联系我们</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  data() {
    return {
      mobileMenuOpen: false,
      isRestrictedRegion: false,
      versionData: null
    }
  },
  computed: {
    iosButtonText() {
      return this.isRestrictedRegion ? '下载iOS安装包' : 'App Store'
    },
    iosDownloadUrl() {
      if (this.isRestrictedRegion && this.versionData?.ios?.withVpnDownloadUrl) {
        return this.versionData.ios.withVpnDownloadUrl
      }
      return 'https://apps.apple.com/cn/app/id6761066100'
    },
    androidDownloadUrl() {
      if (this.isRestrictedRegion && this.versionData?.android?.withVpnDownloadUrl) {
        return this.versionData.android.withVpnDownloadUrl
      }
      return this.versionData?.android?.androidUrl || '#'
    },
    pcDownloadUrl() {
      if (this.isRestrictedRegion && this.versionData?.pc?.withVpnDownloadUrl) {
        return this.versionData.pc.withVpnDownloadUrl
      }
      return this.versionData?.pc?.pcUrl || '#'
    }
  },
  async mounted() {
    await this.detectRegionAndFetchVersions()
  },
  methods: {
    async getRegionByIp() {
      try {
        const { data } = await axios.get('/api/ip-json', {
          params: { json: true },
          timeout: 5000
        })
        return data.pro || ''
      } catch {
        return ''
      }
    },
    async detectRegionAndFetchVersions() {
      try {
        const province = await this.getRegionByIp()
        const restrictedRegions = ['江苏', '浙江', '上海']
        this.isRestrictedRegion = restrictedRegions.some(r => province.includes(r))
      } catch {
        this.isRestrictedRegion = false
      }

      try {
        const { data: versionJson } = await axios.get('https://api.chatzxb.com/api/system/allLatestVersions')
        if (versionJson.code === 200) {
          this.versionData = versionJson.data
        }
      } catch {
        this.versionData = null
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary: #07C9B5;
  --primary-dark: #06a89a;
  --primary-light: #059e8e;
  --secondary: #0ae8d1;
  --bg: #ffffff;
  --bg-card: #f0fdfb;
  --bg-card-hover: #e6faf7;
  --text: #1a2e2b;
  --text-muted: #4a6b66;
  --border: rgba(7, 201, 181, 0.25);
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  background: linear-gradient(180deg, #ffffff 0%, #e6faf7 30%, #ffffff 50%, #e6faf7 75%, #ccf5ef 100%);
  color: var(--text);
  line-height: 1.6;
  overflow-x: hidden;
}

#app {
  margin: 0;
  text-align: left;
}

.app {
  min-height: 100vh;
}

/* Navbar */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: cover;
}

.logo-icon.small {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  object-fit: cover;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-links {
  display: flex;
  gap: 32px;
}

.nav-links a {
  color: var(--text-muted);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: var(--primary-light);
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.mobile-menu-btn span {
  width: 24px;
  height: 2px;
  background: #1a2e2b;
  border-radius: 2px;
  transition: 0.3s;
}

/* Hero */
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding-top: 72px;
  overflow: hidden;
}

.hero-bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.15;
}

.shape-1 {
  width: 500px;
  height: 500px;
  background: #07C9B5;
  top: -100px;
  right: -100px;
  animation: float 8s ease-in-out infinite;
}

.shape-2 {
  width: 400px;
  height: 400px;
  background: #0ae8d1;
  bottom: -50px;
  left: -100px;
  animation: float 10s ease-in-out infinite reverse;
}

.shape-3 {
  width: 300px;
  height: 300px;
  background: #07C9B5;
  top: 50%;
  left: 50%;
  animation: float 12s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(30px, -30px); }
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.hero-content h1 {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 24px;
}

.hero-brand {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  color: var(--text);
}

.hero-desc {
  font-size: 1.125rem;
  color: var(--text-muted);
  margin-bottom: 32px;
  max-width: 480px;
}

.hero-actions {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 28px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: white;
  box-shadow: 0 4px 20px rgba(7, 201, 181, 0.4);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(7, 201, 181, 0.5);
}

.btn-secondary {
  background: rgba(7, 201, 181, 0.1);
  color: var(--primary-light);
  border: 1px solid var(--border);
}

.btn-secondary:hover {
  background: rgba(7, 201, 181, 0.2);
  transform: translateY(-2px);
}

.btn-download {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: white;
  width: 100%;
  padding: 14px 24px;
  box-shadow: 0 4px 15px rgba(7, 201, 181, 0.3);
}

.btn-download:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(7, 201, 181, 0.45);
}

.hero-badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.badge {
  padding: 6px 16px;
  background: rgba(7, 201, 181, 0.1);
  border: 1px solid var(--border);
  border-radius: 20px;
  font-size: 0.85rem;
  color: var(--primary-light);
}

/* Phone Mockup */
.hero-phone {
  display: flex;
  justify-content: center;
}

.phone-frame {
  width: 280px;
  height: 560px;
  background: #ffffff;
  border-radius: 36px;
  border: 3px solid #e0e0e0;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(7, 201, 181, 0.1);
  animation: phoneFloat 6s ease-in-out infinite;
}

@keyframes phoneFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.phone-screen {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fafffe;
}

.phone-header {
  padding: 16px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
}

.phone-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  display: block;
  margin-bottom: 8px;
}

.phone-search {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
}

.chat-list {
  flex: 1;
  overflow: hidden;
  padding: 8px 0;
}

.chat-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  gap: 10px;
  transition: background 0.2s;
}

.chat-item:hover {
  background: rgba(7, 201, 181, 0.05);
}

.chat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  flex-shrink: 0;
  color: white;
}

.chat-avatar.system { background: linear-gradient(135deg, #f59e0b, #ef4444); }
.chat-avatar.group { background: linear-gradient(135deg, #06b6d4, #3b82f6); }
.chat-avatar.user1 { background: linear-gradient(135deg, #10b981, #059669); }
.chat-avatar.user2 { background: linear-gradient(135deg, #8b5cf6, #6366f1); }
.chat-avatar.user3 { background: linear-gradient(135deg, #ec4899, #f43f5e); }

.chat-info {
  flex: 1;
  min-width: 0;
}

.chat-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 2px;
}

.chat-msg {
  font-size: 0.7rem;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-time {
  font-size: 0.65rem;
  color: var(--text-muted);
  white-space: nowrap;
}

.phone-tab-bar {
  display: flex;
  border-top: 1px solid rgba(7, 201, 181, 0.2);
  padding: 10px 0;
  background: #fafffe;
}

.phone-tab-bar .tab {
  flex: 1;
  text-align: center;
  font-size: 0.7rem;
  color: var(--text-muted);
}

.phone-tab-bar .tab.active {
  color: var(--primary);
  font-weight: 600;
}

/* Features */
.features {
  padding: 100px 0;
  position: relative;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-title {
  text-align: center;
  font-size: 2.25rem;
  font-weight: 800;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #1a2e2b, #07C9B5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: var(--text-muted);
  font-size: 1.1rem;
  margin-bottom: 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.feature-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 32px 24px;
  text-align: center;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(7, 201, 181, 0.06);
}

.feature-card:hover {
  background: var(--bg-card-hover);
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(7, 201, 181, 0.15);
}

.feature-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
}

.feature-card h3 {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--text);
}

.feature-card p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
}

/* Security */
.security {
  padding: 100px 0;
  background: linear-gradient(180deg, transparent, rgba(7, 201, 181, 0.08), transparent);
}

.security-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.security-text h2 {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 1.3;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #1a2e2b, #07C9B5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.security-text p {
  color: var(--text-muted);
  font-size: 1.05rem;
  margin-bottom: 24px;
  line-height: 1.7;
}

.security-tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.sec-tag {
  padding: 8px 18px;
  background: rgba(7, 201, 181, 0.1);
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 0.85rem;
  color: var(--primary-light);
  font-weight: 500;
}

.security-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sec-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.3s;
}

.sec-card:hover {
  background: var(--bg-card-hover);
  transform: translateX(4px);
}

.sec-card-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.sec-card h4 {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 4px;
  color: var(--text);
}

.sec-card p {
  font-size: 0.85rem;
  color: var(--text-muted);
}

/* Download */
.download {
  padding: 100px 0;
}

.download-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.download-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 40px 28px;
  text-align: center;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(7, 201, 181, 0.06);
}

.download-card:hover {
  background: var(--bg-card-hover);
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(7, 201, 181, 0.15);
}

.download-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 20px;
}

.download-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.download-req {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-bottom: 24px;
}

/* Footer */
.footer {
  border-top: 1px solid var(--border);
  padding: 40px 0;
  background: linear-gradient(180deg, transparent, rgba(7, 201, 181, 0.05));
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text);
}

.footer-tagline {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.footer-links {
  display: flex;
  gap: 24px;
}

.footer-links a {
  color: var(--text-muted);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: var(--primary-light);
}

/* Responsive */
@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .mobile-menu-btn {
    display: flex;
  }

  .nav-links {
    position: absolute;
    top: 72px;
    left: 0;
    right: 0;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    gap: 16px;
    border-bottom: 1px solid var(--border);
    display: none;
  }

  .nav-links.active {
    display: flex;
  }

  .hero-container {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 40px 24px;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }

  .hero-desc {
    margin: 0 auto 32px;
  }

  .hero-actions {
    justify-content: center;
  }

  .hero-badges {
    justify-content: center;
  }

  .hero-phone {
    order: -1;
  }

  .phone-frame {
    width: 240px;
    height: 480px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .security-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .security-tags {
    justify-content: center;
  }

  .download-grid {
    grid-template-columns: 1fr;
  }

  .footer-container {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .footer-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
